import React from 'react'
import { fetchMaterialConnections } from './hooks/fetchers'
import MaterialConnectionGrid from './components/materialConnectionsGrid'
const MaterialIndex = () => {
  return (
    <MaterialConnectionGrid />
  )
}

export default MaterialIndex